import type { GridCell } from '@glideapps/glide-data-grid';
import { isTickerCell } from '../../CustomCell/Ticker';

export const findMatchingTickerCellRows = (
  uniqueSymbol: string,
  tickerColumn: GridCell[] = []
) => {
  const matchRows: number[] = [];
  for (let rowIndex = 0; rowIndex < tickerColumn.length; rowIndex++) {
    const cell = tickerColumn[rowIndex];
    if (!isTickerCell(cell)) continue;
    if (cell.data.uniqueSymbol !== uniqueSymbol) continue;
    matchRows.push(rowIndex);
  }
  return matchRows;
};
